import { IdentifiedOnboardingGroup } from '@models/IdentifiedOnboardingGroup.model';
import { useContext, useMemo, useState } from 'react';
import { OnboardingFileContext } from '../../OnboardingFile.query';
import { GroupRow } from '../GroupRow/GroupRow';
import { ProductMatchDetailsDialog } from '../ProductMatchDetailsDialog/ProductMatchDetailsDialog';
import {
  IdentifiedGroupWrapper,
  MatchedToWrapper,
  MatchedItem,
  Title,
  NoText,
  MatchedTitle,
  ProductDetailsActionItem,
} from './IdentifiedGroupedFile.styles';

interface IMatchedItemText {
  label: string;
}

const MatchedItemText = ({ label }: IMatchedItemText) => {
  if (!label) {
    return <NoText>Empty</NoText>;
  }
  return <MatchedItem>{label}</MatchedItem>;
};

interface IIdentifiedGroupedFile {
  groups: IdentifiedOnboardingGroup;
}

export const IdentifiedGroupedFile = ({ groups }: IIdentifiedGroupedFile) => {
  const [openMatchDetails, setOpenMatchDetails] = useState(false);

  const { selectedProductId } = useContext(OnboardingFileContext);

  const productId = useMemo(() => {
    return groups.groups[0].items[0].productId;
  }, []);

  return (
    <IdentifiedGroupWrapper>
      <ProductMatchDetailsDialog
        open={openMatchDetails}
        onClose={() => setOpenMatchDetails(false)}
      />
      <>
        <MatchedTitle>Matched to:</MatchedTitle>
        <MatchedToWrapper>
          <MatchedItemText label={groups.matchedTo.split('::')[0]} />
          <MatchedItemText label={groups.matchedTo.split('::')[1]} />
          <MatchedItemText label={groups.matchedTo.split('::')[2]} />
          <ProductDetailsActionItem
            onClick={async () => {
              await selectedProductId.set(productId);
              setOpenMatchDetails(true);
            }}
          >
            Product Details
          </ProductDetailsActionItem>
          <div />
        </MatchedToWrapper>
      </>
      <Title>Your Details</Title>
      {groups.groups.map(group => {
        return <GroupRow key={group.id} group={group} />;
      })}
    </IdentifiedGroupWrapper>
  );
};
